module.exports = "/_next/static/images/gurugram-08a8c01c30f0ce81df1a0864863e13de.png";